import { render, staticRenderFns } from "./ClaudeAiAssistant.vue?vue&type=template&id=c9c129e0&scoped=true"
import script from "./ClaudeAiAssistant.vue?vue&type=script&lang=js"
export * from "./ClaudeAiAssistant.vue?vue&type=script&lang=js"
import style0 from "./ClaudeAiAssistant.vue?vue&type=style&index=0&id=c9c129e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c129e0",
  null
  
)

export default component.exports